/**
 * 应用入口文件：挂载 React 应用到 DOM 根节点。
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import { initializeRum } from '@/lib/rum'
import '@/index.css'
import 'react-photo-view/dist/react-photo-view.css'

const rootElement: HTMLElement | null = document.getElementById('root')

if (rootElement === null) {
  throw new Error('Root element not found')
}

initializeRum()

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
